import { useQuery } from "@tanstack/react-query";

import { MediaData } from "../../../models/MediaData";
import DataSvc from "../../../services/dataSvc";

const useLocationMediaList = (locationId: string) => {
  const query = useQuery<MediaData[]>(["location.media", locationId], () => {
    if (locationId) {
      return DataSvc.getMedia({
        limit: 10,
        offset: 0,
        order: "desc",
        sort: "post_date",
        location_id: [locationId],
      });
    }
    return [];
  });

  return query;
};

export default useLocationMediaList;
